import type { GetSanAdAccountZeitStatusAction } from '../../actions/getSANAdPartnerZeitStatus';
import type { GetTikTokSANAdvertisersAction } from './getAdvertisers.action';
import type { GetTikTokSANAuthenticationUrlAction } from './getAuthenticationUrl.action';

export * from './getAuthenticationUrl.action';
export * from './getAdvertisers.action';

export type TikTokSANAction =
  | GetTikTokSANAuthenticationUrlAction
  | GetSanAdAccountZeitStatusAction
  | GetTikTokSANAdvertisersAction;
